// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"AddEditTransactionModal_modalBackdrop__-JGDX","dialog":"AddEditTransactionModal_dialog__MNfKe"};